
import Vue from 'vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
let VUE = new Vue();

import { specState,cartHandle } from './specState'

export default {

query(opts){
let _this = this;

opts.loading = typeof opts.loading === 'undefined' ? true : (
opts.loading || false
)

opts.loading && this.loading();

return new Promise((resolve,reject)=>{

let queryOpts = {
url: opts.url,
data: opts.data,
type: opts.type || 'POST',
async: opts.async || true,
dataType: 'json',
contentType: opts.contentType, // 设置传递类类型 请求头
processType: opts.processType, // 设置传递类型 json
success: function(data){

opts.loading && _this.loading(false);
switch(data.code){
case 1:
reject(data);
break;
case 0:
resolve(data);
break;
default:
reject(data);
break;
}
},
error: function(data){

opts.loading && _this.loading(false);

var tips = '';
switch(data.status){
case 0:
tips = '网络请求失败，请重试:';
break;
case 403:
tips = '用户未登录:';
_this.storage("userInfo",'');
location.href = '/login';  
break;
case 400:
tips = '请求错误，请重试:';
break;
case 500:
tips = '服务端请求错误，请重试:';
break;
default:
tips = '访问失败,错误代码:';
break;

}
const err = {
success: false,
code: data.status,
message: tips + data.status,
data: null,
}
reject(err);
}
};

if(typeof opts.headers==='undefined'|| typeof opts.headers==='null'|| opts.headers==true){
queryOpts['headers'] = {
'x-token': this.storageJson('userInfo') ? this.storageJson('userInfo').token : '',
}
}
this.ajax(queryOpts);
});

},

keydown(){
document.onkeydown = function (e) { // 回车提交表单

var theEvent = window.event || e;
var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
if (code == 13) {
console.log(111)
}
}
},


loading(v){

const loading = document.querySelector("#lo_loading");

if(v != false){
loading.setAttribute("class","active");
return;
}

loading.removeAttribute("class");








},


storage(key,value){
if(arguments.length===1){
return localStorage.getItem(key);
}
if(typeof value==='string' && value.length===0){
return localStorage.removeItem(key);
}
return localStorage.setItem(key, value);
},


getCurStoreId(){
let id = parseInt(localStorage.getItem('loc_store_id'));
if(!id || isNaN(id)){
id = 2;
localStorage.setItem('loc_store_id', String(id));
}
return id;
},
setCurStoreId(id){
if(id) localStorage.setItem('loc_store_id', String(id));
},
getCurStoreCity(){
return localStorage.getItem('loc_store_city') || '';
},

setCurStore(store){
if(!store || !store.store_id) return;
localStorage.setItem('loc_store_id', String(store.store_id));
if(store.region_city) localStorage.setItem('loc_store_city', store.region_city);
if(store.lng && store.lat){
localStorage.setItem('location', JSON.stringify({
longitude: Number(store.lng),
latitude: Number(store.lat)
}));
}
},


storageJson(key,value){

if(arguments.length===1){
let info = JSON.parse(localStorage.getItem(key));
return info || null;
}

if(typeof value === 'string' && value === ''){
return localStorage.removeItem(key);
}

if(typeof value === 'object'){
return localStorage.setItem(key,JSON.stringify(value));
}
},


session(key,value){
if(arguments.length===1){
return sessionStorage.getItem(key);
}
if(typeof value==='string' && value.length===0){
return sessionStorage.removeItem(key);
}
return sessionStorage.setItem(key, value);

},


sessionJson(key,value){

if(arguments.length===1){
let info = JSON.parse(sessionStorage.getItem(key));
return info || null;
}

if(typeof value === 'string' && value === ''){
return sessionStorage.removeItem(key);
}

if(typeof value === 'object'){
return sessionStorage.setItem(key,JSON.stringify(value));
}
},


trimSpace(v){
return v.replace(/\s+/g,'');
},


formatDate(v,type){
let y = this.fillZore(v.getFullYear());
let m = this.fillZore(v.getMonth() + 1);
let d = this.fillZore(v.getDate());
let h = this.fillZore(v.getHours());
let i = this.fillZore(v.getMinutes());
let s = this.fillZore(v.getSeconds());

if(type=='ymd'){
return y+'-'+m+'-'+d;
}else{
return y+'-'+m+'-'+d+' '+h+':'+i+':'+s;
}
},


fillZore(v){
return v >= 10 ? v : '0' + v;
},


isMobile(str){
var reg = /^1[0-9][0-9]{9}$/;
return reg.test(str) ? !0: !1
},

isMobileCode(str){
var reg = /^\d{4}$/i;
return reg.test(str);
},

isNum(n,type){
var regInt = /^[1-9]\d{0,}$/;
var regFloat = /(^[0-9]\d{0,}$)|(^[0-9]\d{0,}\.[0-9]{1,}$)/;
if(type=='float'){
return regFloat.test(n);
}else{
return regInt.test(n);
}
},


urlMerge(obj){
let query = [];
for(let x in obj){
if( obj[x]==='' || obj[x]===undefined ){
continue;
}
if( typeof obj[x]==='string'||typeof obj[x]==='number' || typeof obj[x]==='boolean' ){
query.push( x + '=' + obj[x] );
continue;
}
if( obj[x] instanceof Array ){
obj[x].forEach(arr=>{
query.push( x + '[]' + '=' + arr );
})
}
}
return query.join('&');
},

ajax(opt){

let xhr = new XMLHttpRequest();


xhr.onreadystatechange=function(){
if(xhr.readyState==4){
if(xhr.status == 200){

return opt.success(opt.dataType == 'json' ? JSON.parse(xhr.responseText) : xhr.responseText);
}else{
return opt.error(xhr);
}
}else{

}
}

xhr.onloadend = function(e){
if(xhr.status!=200){
return opt.error(xhr);
}
}



if(opt.type==='GET' || opt.type==='get'){
let url = opt.url+'?' + this.urlMerge(opt.data);
xhr.open(opt.type,url,opt.async);

if(typeof opt.headers === 'object'){
for(let h in opt.headers){
xhr.setRequestHeader(h,opt.headers[h]);
}
}
xhr.send();
}

if(opt.type==='PUT' || opt.type==='put'){
let url = opt.url+'?' + this.urlMerge(opt.data);

xhr.open('PUT',url);


if(typeof opt.headers === 'object'){
for(let h in opt.headers){
xhr.setRequestHeader(h,opt.headers[h]);
}
}
xhr.send(opt.data);
}

if(opt.type==='DELETE' || opt.type==='delete'){
let url = opt.url+'?' + this.urlMerge(opt.data);

xhr.open('delete',url);

if(typeof opt.headers === 'object'){
for(let h in opt.headers){
xhr.setRequestHeader(h,opt.headers[h]);
}
}
xhr.send(opt.data);
}

if(opt.type==='POST' || opt.type==='post'){
xhr.open(opt.type,opt.url,opt.async);


if(typeof opt.headers === 'object'){
for(let h in opt.headers){
xhr.setRequestHeader(h,opt.headers[h]);
}
}



if(typeof opt.contentType==='string'){
xhr.setRequestHeader('Content-Type',opt.contentType);
}

if(typeof opt.contentType==='undefined'){
xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
}

if(typeof opt.contentType==='boolean'){

}



if(typeof opt.processType==='undefined'){
xhr.send(this.urlMerge(opt.data));
}


if(opt.processType==='file'){
xhr.send(opt.data);
}


if(opt.processType === 'JSON'){
xhr.send(JSON.stringify(opt.data));
}

}

},

}

export {
specState,
cartHandle,
}



// WEBPACK FOOTER //
// ./src/assets/js/Common.js